// Day 17 Mobile #18: convert FAQ page flat h3+content layout into native
// <details>/<summary> accordion structure on page load. All FAQ items
// default-closed; users expand on click.
//
// Page body authoring stays unchanged (admin-managed h2 categories +
// h3 questions + paragraph/list answers); the script wraps each h3 plus
// its following siblings (up to the next h3, h2, or container end) in
// a <details> element with the h3 text as the summary.
//
// Idempotent: skips conversion if h3 already lives inside a <details>.
// Graceful: if a different layout pattern is on the page the script
// no-ops (no h3 found = no work).

(function () {
  'use strict';
  function convertFaqPage(root) {
    if (!root) return;
    var h3s = Array.from(root.querySelectorAll('h3'));
    if (h3s.length === 0) return 0;
    var converted = 0;
    h3s.forEach(function (h3) {
      // Skip if already inside a details element.
      if (h3.closest('details') || h3.closest('summary')) return;

      // Collect siblings between this h3 and next h3 / h2.
      var siblings = [];
      var sibling = h3.nextElementSibling;
      while (sibling && sibling.tagName !== 'H3' && sibling.tagName !== 'H2') {
        siblings.push(sibling);
        sibling = sibling.nextElementSibling;
      }
      if (siblings.length === 0) return; // No content to collapse.

      // Build <details><summary>h3 text</summary><div>siblings</div></details>.
      var details = document.createElement('details');
      details.className = 'os-faq-item';
      var summary = document.createElement('summary');
      summary.className = 'os-faq-item__summary';
      // Preserve h3 inner HTML (for any inline formatting).
      summary.innerHTML = h3.innerHTML;
      details.appendChild(summary);
      var contentWrap = document.createElement('div');
      contentWrap.className = 'os-faq-item__content';
      siblings.forEach(function (s) { contentWrap.appendChild(s); });
      details.appendChild(contentWrap);

      h3.parentNode.insertBefore(details, h3);
      h3.parentNode.removeChild(h3);
      converted++;
    });
    return converted;
  }

  function init() {
    // Find the FAQ content container. Prefer .shopify-policy__container
    // or .page-content scope; fall back to main element.
    var roots = [
      document.querySelector('.shopify-policy__container'),
      document.querySelector('.page-content'),
      document.querySelector('main .section.page-width-content'),
      document.querySelector('main'),
    ].filter(Boolean);
    if (roots.length === 0) return;
    var totalConverted = 0;
    roots.forEach(function (r) {
      var n = convertFaqPage(r) || 0;
      totalConverted += n;
    });
    if (totalConverted > 0) {
      document.documentElement.setAttribute('data-os-faq-accordion', 'on');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
